import React from 'react';
import LiroyText from './LiroyText';
import { defaultFont } from '../../../assets/fonts/defaultFont';

export default function TextMedium24({ children, ...props }) {
    return (
        <LiroyText
            {...props}
            size={24}
            fontWeight={defaultFont.medium}
        >
            {children}
        </LiroyText>
    );
}